import React from 'react';
import { Tag, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

const { Text } = Typography;

const columns = (t, module, view = 'all', filterBy = 'show', activeFilters = {}) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'datastakeId',
      key: 'datastakeId',
      show: true,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      render: id => (
        <NavLink className="projectLink" to={`/app/${module}/viewdd/document/${id}`}>
          {id}
        </NavLink>
      ),
      search: true,
      publication: true,
      width: 160,
      views: ['document', 'picture', 'link', 'asmo']
    },
    {
      title: t('Type'),
      dataIndex: 'type',
      ellipsis: true,
      key: 'type',
      // defaultSortOrder: activeFilters.sortBy === 'type' ? activeFilters.sortDir : undefined,
      // sorter: () => 0 + 0,
      render: (type, all) => {
        if (view === 'document') {
          return type;
        }
        return all?.typeOfDocument;
      },
      show: true,
      publication: true,
      search: true,
      searchType: 'dropdown',
      views: ['all', 'all', 'all', 'document']
    },
    {
      title: t('Link'),
      dataIndex: 'link',
      key: 'link',
      defaultSortOrder: activeFilters.sortBy === 'link' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      render: link => {
        return <a href={link} target="_blank" rel="noreferrer" >
          {link}
        </a>
      },
      show: true,
      publication: true,
      search: true,
      views: ['link']
    },
    {
      title: t('Title'),
      dataIndex: 'title',
      key: 'title',
      defaultSortOrder: activeFilters.sortBy === 'title' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      ellipsis: true,
      width: '36%',
      render: title => {
        return title
      },
      show: true,
      primarySearch: true,
      publication: true,
      views: ['document', 'picture', 'link', 'asmo']
    },
    {
      title: t('Source'),
      dataIndex: 'source',
      key: 'source',
      show: true,
      ellipsis: true,
      search: true,
      publication: true,
      searchType: 'dropdown',
      views: ['document', 'picture', 'link', 'asmo']
    },
    {
      title: t('Associated Stakeholders'),
      width: 180,
      dataIndex: 'associatedStakeholder',
      key: 'associatedStakeholder',
      // ellipsis: true,
      sorter: false,
      render: associatedStakeholders => {
        return associatedStakeholders ? (
          <>
            {(associatedStakeholders || []).map((c, i) => {
              return (
                <Tag key={i}>
                  <Text ellipsis={{ tooltip: c }} style={{ maxWidth: '100px' }}>{c}</Text>
                </Tag>
              )
            })}
          </>
        ) : null
      },
      show: true,
      search: true,
      publication: true,
      searchType: 'dropdown',
      views: ['document', 'link']
    },
    {
      title: t('Location'),
      dataIndex: 'associatedLocations',
      key: 'associatedLocations',
      sorter: false,
      ellipsis: true,
      render: associatedLocations => {
        return associatedLocations ? (
          <>
            {(associatedLocations || []).map((c, i) => {
              return (
                <Tag key={i}>
                  <Text ellipsis={{ tooltip: c }} style={{ maxWidth: '100px' }}>{c}</Text>
                </Tag>
              )
            })}
          </>
        ) : null
      },
      show: true,
      search: true,
      publication: true,
      searchType: 'dropdown',
      views: ['picture']
    },
    {
      title: t('Availability'),
      dataIndex: 'availability',
      ellipsis: true,
      key: 'availability',
      // defaultSortOrder: activeFilters.sortBy === 'availability' ? activeFilters.sortDir : undefined,
      // sorter: () => 0 + 0,
      render: title => {
        return title;
      },
      show: true,
      search: true,
      publication: true,
      searchType: 'dropdown',
      views: ['document', 'picture']
    },
    {
      title: t('Date'),
      dataIndex: 'date',
      ellipsis: true,
      key: 'date',
      show: true,
      publication: true,
      defaultSortOrder: activeFilters.sortBy === 'date' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      render: date => date ? moment(date).format('DD MMM YYYY') : '',
      search: true,
      searchType: 'date',
      views: ['document', 'picture', 'link', 'asmo']
    },
  ];
  if (view === 'all') {
    return cols.filter(c => c[filterBy] && c.views.length === 4);
  }
  return cols.filter(c => c[filterBy] && c.views.includes(view));
}
export default columns;
